import storeFactory from '@/helpers/storeFactory'

const createModel = () => ({
  event_uuid: null,
  subject: null,
  routes: [],
  replacements: [],
  yellow_vests: [],
  train_deviations: [],
  delays: [],
  turnarounds: [],
  forecast_comment: null,
  replacement_comment: null,
  yellow_vest_comment: null,
  consequence: null
})

export default storeFactory({
  model: createModel(),
  mutations: {
    resetModel(state) {
      state.model = createModel()
    }
  },
  getters: {
    newItemsCount(state, _, __, rootGetters) {
      const newReplacementsCount = rootGetters['replacement/newItemsCount']
      const newDelayCount = rootGetters['delay/newItemsCount']
      const newTrainDeviationsCount =
        rootGetters['trainDeviation/newItemsCount']
      const newTurnaroundsCount = rootGetters['turnaround/newItemsCount']
      const newYellowVestCount = rootGetters['yellowVest/newItemsCount']

      const lastTrafficMessage =
        rootGetters['event/selectedEvent']?.last_traffic_message

      if (!lastTrafficMessage) return 0

      const diffForecastComment = () =>
        lastTrafficMessage.forecast_comment !== state.model.forecast_comment
      const diffYellowVestComment = () =>
        lastTrafficMessage.yellow_vest_comment !==
        state.model.yellow_vest_comment
      const diffReplacementComment = () =>
        lastTrafficMessage.replacement_comment !==
        state.model.replacement_comment
      const diffConsequence = () =>
        lastTrafficMessage.consequence !== state.model.consequence

      return [
        newReplacementsCount,
        newDelayCount,
        newTrainDeviationsCount,
        newTurnaroundsCount,
        newYellowVestCount,
        lastTrafficMessage
          ? diffForecastComment() ||
            diffYellowVestComment() ||
            diffReplacementComment() ||
            diffConsequence()
          : 0
      ].reduce((a, b) => {
        a = a + b
        return a
      }, 0)
    },

    missingItemsCount(state, _, __, rootGetters) {
      const missingReplacementsCount =
        rootGetters['replacement/missingItemsCount']
      const missingDelayCount = rootGetters['delay/missingItemsCount']
      const missingTrainDeviationsCount =
        rootGetters['trainDeviation/missingItemsCount']
      const missingTurnaroundsCount =
        rootGetters['turnaround/missingItemsCount']
      const missingYellowVestCount = rootGetters['yellowVest/missingItemsCount']

      return [
        missingReplacementsCount,
        missingDelayCount,
        missingTrainDeviationsCount,
        missingTurnaroundsCount,
        missingYellowVestCount
      ].reduce((a, b) => {
        a = a + b
        return a
      }, 0)
    },

    diffItemsCount(state, getters) {
      return (
        getters['newItemsCount'] +
        getters['missingItemsCount'] +
        getters['diffSubjectCount'] +
        getters['diffRoutesCount']
      )
    },

    diffSubjectCount(state, _, __, rootGetters) {
      return state.model.subject !== rootGetters['event/selectedEvent'].title
        ? 1
        : 0
    },

    diffRoutesCount(state, _, __, rootGetters) {
      const eventRoutesIds = (
        rootGetters['event/selectedEvent']?.routes || []
      ).map(x => x.uuid)
      const currentEventRouteIds = state.model.routes || []
      if (eventRoutesIds.length !== currentEventRouteIds.length) return 1
      const isDiff = !currentEventRouteIds.every(id =>
        eventRoutesIds.some(eId => eId === id)
      )

      return isDiff ? 1 : 0
    }
  }
})
